import React, { useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import arrowForwardIosOutlined from "../../assets/images/chats/down_arrow.svg";
import { accountType } from "../../utils/constant";
import AlertPopUp from "../../common/AlertPopUp";
import useAppSelectors from "../../customHooks/useAppSelectors";
import { crossIcon, crossIconDiv } from "../../assets/commonFunction";
import DateTimeFormatDialog from "./DateTimeFormatDialog";
const data = [
  // { title: "Change email", endpoint: "/changeemail" },
  {
    title: "Reset password",
    actionName: "resetpassword",
  },
  {
    title: "Date & time format",
    actionName: "datetimeformat",
  },
  {
    title: "Delete account",
    actionName: "deleteaccount",
  },
];
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
    position: "relative",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
    mb: "1rem",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const Settings = ({
  setSettingDrawerOpen,
  setResetPasswordDrawerOpen,
  setDeleteAccountDrawerOpen,
}) => {
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isDateTimeFormatOpen, setDateTimeFormatOpen] = useState(false);

  const { currentUserData } = useAppSelectors();

  const handleClickItem = (type) => {
    switch (type) {
      case "resetpassword":
        setResetPasswordDrawerOpen(true);
        return;
      case "datetimeformat":
        setDateTimeFormatOpen(true);
        return;
      case "deleteaccount":
        const accounteOwned = currentUserData?.subscribedTo?.filter(
          (item) => item?.accountOwner === currentUserData?.id
        );
        const haveOrgAccount = accounteOwned?.filter(
          (item) => item?.subscriberPriority === accountType?.Organisation
        );
        if (
          currentUserData?.activeSubscriber?.subscriberPriority ===
          accountType?.Organisation
        ) {
          setDeleteAccountDrawerOpen(true);
        } else if (haveOrgAccount?.length === 0) {
          setDeleteAccountDrawerOpen(true);
        } else {
          setAlertModalOpen(true);
        }
        return;
      default:
        return;
    }
  };

  return (
    <Box sx={classes.drawerBody}>
      <AlertPopUp
        title={"Alert."}
        bodyContent={"Delete Your Orgaisation Account First"}
        open={isAlertModalOpen}
        closeModal={setAlertModalOpen}
      />
      <DateTimeFormatDialog
        open={isDateTimeFormatOpen}
        onClose={() => setDateTimeFormatOpen(false)}
      />
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon
            sx={classes.iconn}
            onClick={() => setSettingDrawerOpen(false)}
          />
        </Typography>
        <Typography color={"black"}>Settings</Typography>
      </Stack>

      <>
        <Box width={"85%"} margin={"auto"}>
          <Box
            overflow={"auto"}
            maxHeight={"280px"}
            width={"95%"}
            sx={{
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { width: "0px" },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": { background: "transparent" },
            }}
          >
            {data?.map((item) =>
              item.actionName === "deleteaccount" && !currentUserData?.accountOwner ? null : ( 
                <Box
                  key={item?.title + "settings" + item?.actionName}
                  onClick={() => handleClickItem(item?.actionName)}
                  bgcolor={"#E1E1E1"}
                  sx={{ cursor: "pointer", borderRadius: "2px" }}
                  mb={"0.9rem"}
                  p={"0.5rem 1rem"}
                  position={"relative"}
                >
                  <Typography
                    color={"black"}
                    fontSize={"0.87rem"}
                    fontWeight={400}
                  >
                    {item?.title}
                  </Typography>
                  <Box position={"absolute"} right={"0.4rem"} top={"20%"}>
                    <img src={arrowForwardIosOutlined} alt="logo" />
                  </Box>
                </Box>
              )
            )}
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default Settings;

